import { render } from "./inputFile.vue?vue&type=template&id=0168d8e8&scoped=true&ts=true"
import script from "./inputFile.vue?vue&type=script&lang=ts"
export * from "./inputFile.vue?vue&type=script&lang=ts"

import "./inputFile.vue?vue&type=style&index=0&id=0168d8e8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0168d8e8"]])

export default __exports__